import React from 'react';
import { Link } from 'react-router-dom';
import { Button, Form, Header, Segment } from 'semantic-ui-react';

const INTEGRATION_TYPES = [
  {key: 'salesforce', text: 'Salesforce', value: 'salesforce'},
  {key: 'dynamics', text: 'Dynamics 365', value: 'dynamics'},
];

const EXAMPLE_ORG_IDS = {
  salesforce: '00DXXXYYYZZZAAA',
  dynamics: '1f097332-0226-4956-aeef-f2af6e1bcabd',
};

class CreateAccountForm extends React.Component {
  state = {
    integration: {type: 'salesforce'},
  };

  render() {
    const { integration } = this.state;
    return (
      <Form>
        <Form.Input label="Name" placeholder="Account Name" required />
        <Segment>
          <Header as="h3">
            Integration
          </Header>
          <Form.Group widths="equal">
            <Form.Select label="Type" options={INTEGRATION_TYPES} value={integration.type} onChange={this.handleChangeIntegrationType} />
            <Form.Input label="Org ID" placeholder={EXAMPLE_ORG_IDS[integration.type]} />
          </Form.Group>
        </Segment>
        <Button primary>Create</Button>
        <Button as={Link} to="/o/accounts">Cancel</Button>
      </Form>
    );
  }

  handleChangeIntegrationType = (e, option) => {
    e.preventDefault();
    const type = option.value;
    this.setState((state) => ({...state, integration: {...state.integration, type}}));
  };
}

export default CreateAccountForm;
